/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_CropInputs */

const en_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Crop`)
};

const es_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar recorte`)
};

const fr_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer le recadrage`)
};

const de_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuschnitt anwenden`)
};

const ja_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切り抜きを適用`)
};

const zh_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用裁剪`)
};

const ar_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق الاقتطاع`)
};

const id_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terapkan Potongan`)
};

const it_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica ritaglio`)
};

const ru_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить кадрирование`)
};

const pt_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar corte`)
};

const ko_apply_crop = /** @type {(inputs: Apply_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자르기 적용`)
};

/**
* | output |
* | --- |
* | "Apply Crop" |
*
* @param {Apply_CropInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const apply_crop = /** @type {((inputs?: Apply_CropInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_CropInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_apply_crop(inputs)
	if (locale === "es") return es_apply_crop(inputs)
	if (locale === "fr") return fr_apply_crop(inputs)
	if (locale === "de") return de_apply_crop(inputs)
	if (locale === "ja") return ja_apply_crop(inputs)
	if (locale === "zh") return zh_apply_crop(inputs)
	if (locale === "ar") return ar_apply_crop(inputs)
	if (locale === "id") return id_apply_crop(inputs)
	if (locale === "it") return it_apply_crop(inputs)
	if (locale === "ru") return ru_apply_crop(inputs)
	if (locale === "pt") return pt_apply_crop(inputs)
	return ko_apply_crop(inputs)
});